/* Product slider arrows + product-card swatches (port of BestSellersSlider/ProductCard state). */
if (!customElements.get('product-slider')) {
  customElements.define(
    'product-slider',
    class ProductSlider extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-slider-track]');
        const step = (dir) => {
          const card = track.firstElementChild;
          track.scrollBy({ left: dir * ((card?.clientWidth ?? 0) + 12), behavior: 'smooth' });
        };
        this.querySelector('[data-slider-prev]')?.addEventListener('click', () => step(-1));
        this.querySelector('[data-slider-next]')?.addEventListener('click', () => step(1));
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const swatch = event.target.closest('[data-card-swatch]');
  if (!swatch) return;
  const card = swatch.closest('[data-product-card]');
  card.querySelectorAll('[data-card-swatch]').forEach((s) => {
    s.classList.toggle('border-bloom-green', s === swatch);
    s.classList.toggle('border-transparent', s !== swatch);
  });
  const img = card.querySelector('[data-card-img]');
  if (img && swatch.dataset.image) {
    img.removeAttribute('srcset');
    img.src = swatch.dataset.image;
  }
  card.querySelector('[data-card-price]').textContent = swatch.dataset.price;
  const compare = card.querySelector('[data-card-compare]');
  compare.textContent = swatch.dataset.compare;
  compare.hidden = !swatch.dataset.compare;
  card.querySelector('[data-card-label]').textContent = swatch.dataset.label;
  card.querySelector('[data-card-variant]').value = swatch.dataset.variantId;
  const atc = card.querySelector('[data-card-atc]');
  const available = swatch.dataset.available === 'true';
  atc.disabled = !available;
  atc.textContent = available ? 'Add To Cart' : 'Sold Out';
});
